import React, { useEffect, useState } from "react";
import "./config.scss";
import { Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { fetchAccount, putAccount } from "../../services/AccountService";
import ViewInWeb from "../../components/Common/ViewInWeb";
import meliLogo from "../../assets/images/logo_meli_2.png";

function Config() {
  const [loading, setLoading] = useState(false);
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [twitter, setTwitter] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [telegram, setTelegram] = useState("");
  const [youtube, setYoutube] = useState("");
  const [titleProperties, setTitleProperties] = useState("");
  const [bookingButtonActive, setBookingButtonActive] = useState(true);
  const [bookingButtonUrl, setBookingButtonUrl] = useState("");

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchAccount({
        token: "",
      });
      const {
        facebook,
        instagram,
        linkedin,
        twitter,
        whatsapp,
        telegram,
        youtube,
        title_properties,
        booking_button_active,
        booking_button_url,
      } = response.data.data.config;
      setLoading(false);
      setFacebook(facebook);
      setWhatsapp(whatsapp);
      setInstagram(instagram);
      setLinkedin(linkedin);
      setTwitter(twitter);
      setTelegram(telegram);
      setYoutube(youtube);
      setTitleProperties(title_properties);
      setBookingButtonActive(!!booking_button_active);
      setBookingButtonUrl(booking_button_url || "");
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let response = await putAccount({
        token: "",
        facebook,
        instagram,
        linkedin,
        twitter,
        whatsapp,
        telegram,
        youtube,
        titleProperties,
        bookingButtonActive,
        bookingButtonUrl,
      });
      setLoading(false);
      toast(`Seccíon guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content" id="Config">
        <Container fluid={true}>
          <Breadcrumb title="Configuración" breadcrumbItem="Configuración" />
          <Row>
            <Col>
              <h5>Redes sociales</h5>
              <div className="row">
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Facebook</Label>
                    <Input
                      value={facebook}
                      onChange={(e) => setFacebook(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Instagram</Label>
                    <Input
                      value={instagram}
                      onChange={(e) => setInstagram(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Linkedin</Label>
                    <Input
                      value={linkedin}
                      onChange={(e) => setLinkedin(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Twitter</Label>
                    <Input
                      value={twitter}
                      onChange={(e) => setTwitter(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Whatsapp</Label>
                    <Input
                      value={whatsapp}
                      onChange={(e) => setWhatsapp(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Telegram</Label>
                    <Input
                      value={telegram}
                      onChange={(e) => setTelegram(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Youtube</Label>
                    <Input
                      value={youtube}
                      onChange={(e) => setYoutube(e.target.value)}
                    />
                  </FormGroup>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }}>
            <Col>
              <h5>Propiedades</h5>
              <div className="row">
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <Label>Título</Label>
                    <Input
                      value={titleProperties}
                      onChange={(e) => setTitleProperties(e.target.value)}
                    />
                  </FormGroup>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }}>
            <Col>
              <h5>Botón flotante "Agendar"</h5>
              <div className="row">
                <div className="col-3">
                  <FormGroup className="mb-2">
                    <div className="form-check form-switch">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="bookingButtonActive"
                        checked={bookingButtonActive}
                        onChange={(e) => setBookingButtonActive(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="bookingButtonActive"
                      >
                        Mostrar en la web
                      </label>
                    </div>
                  </FormGroup>
                </div>
                {bookingButtonActive && (
                  <div className="col-6">
                    <FormGroup className="mb-2">
                      <Label>URL de redirección</Label>
                      <Input
                        value={bookingButtonUrl}
                        placeholder="https://mariomendez.uy/agenda"
                        onChange={(e) => setBookingButtonUrl(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                )}
              </div>
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link="https://mariomendez.uy/" />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }}>
            <Col>
              <div style={{ display: "grid" }}>
                <a
                  href="https://auth.mercadolibre.com.uy/authorization?response_type=code&client_id=6852264161711542&redirect_uri=https://panel.mariomendez.uy/authorize"
                  style={{
                    width: "max-content",
                    marginBottom: "1rem",
                    background: "rgb(255 230 0)",
                    border: "none",
                    borderRadius: "5px",
                    padding: "0.5rem 1rem",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  <img
                    src={meliLogo}
                    alt=""
                    style={{
                      width: "30px",
                      marginRight: "0.25rem",
                    }}
                  />
                  Vincular MercadoLibre V2
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Config;
